<template>
    <el-scrollbar :native="false" style="width: 100%;height: 100%;">
        <el-main>
            <div class="screen-form table-operation">
                <el-button type="primary" plain icon="el-icon-circle-plus-outline" @click="addHelp">添加</el-button>
            </div>
            <el-table
                    ref="multipleTable"
                    :data="helpList"
                    tooltip-effect="dark"
                    style="width: 100%"
                    @selection-change="handleSelectionChange">
                <el-table-column prop="title" label="标题"></el-table-column>
                <el-table-column prop="content" label="内容" show-overflow-tooltip></el-table-column>
                <el-table-column prop="createTime" label="创建时间"></el-table-column>
                <el-table-column
                        fixed="right"
                        width="150"
                        label="操作">
                    <template slot-scope="scope">
                        <!--                    <router-link :to="{name:'backEditTenderingMessage'}" target="_blank">-->
                        <el-button
                                size="mini"
                                @click="editHelp(scope.row)"
                        >
                            编辑
                        </el-button>
                        <!--                    </router-link>-->

                        <el-button
                                size="mini"
                                type="danger"
                                @click="handleDelete(scope.row)"
                        >
                            删除
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination-wrap">
                <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="currentPage"
                        :page-sizes="[5, 10, 15, 20, 25, 30,50,100]"
                        :page-size="listPageSize"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="listPageTotal">
                </el-pagination>
            </div>
        </el-main>
    </el-scrollbar>
</template>

<script>
    export default {
        name: "backHelpCenter",
        data(){
            return {
                helpList:[
                    {
                        title:'123',
                        content:'dsfhsjkdf'
                    }
                ],
                listPageTotal:0,
                listPageSize:10,
                currentPage:1,
            }
        },
        mounted(){
            this.requestHelpList();
        },
        methods:{
            addHelp(){
                let {href} = this.$router.resolve({
                    name: 'backEditHelp'
                })
                window.open(href, '_blank')
            },
            editHelp(row){
                let {href} = this.$router.resolve({
                    name: 'backEditHelp',
                    query:{
                        id:row.id
                    }
                })
                window.open(href, '_blank')
            },
            handleDelete(row) {
                this.$confirm('此操作将删除该条数据, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    let loading = this.$loading(this.utils.defaultLoadingOptions);
                    this.$request.deleteHelp({
                        id: row.id
                    }).then(res => {
                        console.log(res)
                        loading.close();
                        if (res.status == 200) {
                            this.$message({
                                type: 'success',
                                message: '删除成功!'
                            });
                            this.requestHelpList();
                        } else {
                            this.$message({
                                type: 'info',
                                message: '删除失败！'
                            });
                            this.requestError(res.status, res.message)
                        }
                    }, err => {
                        console.log(err);
                        loading.close();
                        this.requestFail(err);
                    })

                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });
            },
            handleSelectionChange(val) {//表格选中状态切换
                this.multipleSelection = val;
            },
            handleSizeChange(val) {
                console.log(`每页 ${val} 条`);
                let loading = this.$loading(this.utils.defaultLoadingOptions);
                this.listPageSize = val;
                this.requestHelpList().then(() => {
                    loading.close()
                })
            },
            handleCurrentChange(val) {
                console.log(`当前页: ${val}`);
                let loading = this.$loading(this.utils.defaultLoadingOptions);
                this.currentPage = val;
                this.requestHelpList().then(() => {
                    loading.close()
                })
            },
            requestHelpList(){
                return new Promise(((resolve, reject) => {
                    this.$request.helpList({
                        page:this.currentPage,
                        size:this.listPageSize
                    }).then(res=>{
                        resolve(res);
                        if(res.status==200){
                            this.helpList = res.data.list;
                            this.listPageTotal = res.data.total;
                        }else {
                            this.requestError(res.status,res.message);
                        }
                    },err=>{
                        reject(err);
                        this.requestFail(err);
                    })
                }))

            }
        }
    }
</script>

<style scoped>

</style>